export const BANNER_CONTAINER_TEST_ID = 'banner-container-test-id';
export const BANNER_BLOCK_TEST_ID = 'banner-block-test-id';
export const BANNER_TEXT_WRAPPER_TEST_ID = 'banner-text-wrapper-test-id';
export const BANNER_TEXT_TEST_ID = 'banner-text-test-id';
